import { Component } from '@angular/core';
import { ClipboardService } from '../../../../services/clipboard.service';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

@Component({
	selector: 'app-clipboard',
	standalone: true,
	imports: [AngularModule, ZorroModule, NzTabsModule],
	templateUrl: './clipboard.component.html',
	styleUrl: './clipboard.component.scss',
})
export class ClipboardComponent {
	constructor(public clipboardService: ClipboardService) {}
}
